import { useEffect } from "react";
import { addNewResult, emptyTheResults } from "../features/Slice/sandboxResultSlice";
import { setIsRunning } from "../features/Slice/runningStatusSlice";
import { setSandboxError } from "../features/Slice/sandboxErrorSlice";
import { showToast } from "../components/toast/Toast";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

/**
 *  The component is used to connect to the WebSocket server and listen for events.
 *
 * @returns {JSX.Element}
 */

const webSocketServerPath = process.env.REACT_APP_EVENT_WS;

const Event = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const runningStatus = useSelector((state) => state.runningStatus.data);
    useEffect(() => {
        let ws;
        function connectWebSocket() {
            ws = new WebSocket(
                `${webSocketServerPath}?name=${moment().format("YYYYMMDDHHmmssSSS")}`
            );
            ws.onopen = () => {
                console.log("WebSocket connected");
                ws.send({ operation: "TEST", content: {} });
            };
            ws.onmessage = async (event) => {
                const eventData = JSON.parse(event.data);
                console.log(eventData);
                if (typeof eventData === "object") {
                    switch (eventData.operation) {
                        case "START":
                            dispatch(setIsRunning(true));
                            dispatch(emptyTheResults());
                            break;
                        case "INSERT_RESULTS":
                            dispatch(addNewResult(eventData.content));
                            if (!runningStatus) {
                                dispatch(setIsRunning(true));
                            }
                            break;
                        case "STOP":
                            dispatch(setIsRunning(false));
                            showToast("success", t("ToastSuccess.SandboxSettingSuccess"));
                            break;
                        case "ERROR":
                            dispatch(setIsRunning(false));
                            dispatch(setSandboxError(eventData.content));
                            break;
                        default:
                            break;
                    }
                }
            };
            ws.onerror = (error) => {
                console.log("WebSocket error");
                console.log(error);
            };
            ws.onclose = () => {
                console.log("WebSocket disconnected");
                setTimeout(() => {
                    connectWebSocket();
                }, 500);
            };
        }
        connectWebSocket();
        return () => {
            if (ws) {
                ws.close();
            }
        };
    }, [webSocketServerPath]);
    return <></>;
};

export default Event;
